import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c387c0fe&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/usr/src/app/components/includes/Spinner.vue').default,S2TableCustomizable: require('/usr/src/app/node_modules/front-components/components/ui/table/TableCustomizable.vue').default,EmptyState: require('/usr/src/app/components/includes/EmptyState.vue').default,LineChart: require('/usr/src/app/components/chart/line/LineChart.vue').default,MultiLineChart: require('/usr/src/app/components/chart/line/MultiLineChart.vue').default,CircleChart: require('/usr/src/app/components/chart/CircleChart.vue').default,PyramidChart: require('/usr/src/app/components/chart/PyramidChart.vue').default,DoughnutChart: require('/usr/src/app/components/chart/DoughnutChart.vue').default,ScrollbarWrapper: require('/usr/src/app/components/scroll/ScrollbarWrapper.vue').default})
